export const PaymentData = [
  {
    key: "1",
    id: "#PA-1245",
    payment: "Hotel Atheena Plaza",
    service: "Hotel",
    paymentType: "Card",
    date: "15 May 2025, 10:00 AM",
    amount: "$11,569",
    status: "Completed",
  },
  {
    key: "2",
    id: "#PA-3215",
    payment: "Antonov-12",
    service: "Flight",
    paymentType: "Paypal",
    date: "20 May 2025, 10:00 AM",
    amount: "$12,543",
    status: "Pending",
  },
  {
    key: "3",
    id: "#PA-4581",
    payment: "The Queen of Ocean",
    service: "Cruise",
    paymentType: "Stripe",
    date: "27 May 2025, 10:00 AM",
    amount: "$14,697",
    status: "Completed",
  },
  {
    key: "4",
    id: "#PA-6545",
    payment: "Ford Mustang",
    service: "Car",
    paymentType: "Card",
    date: "12 Jun 2025, 10:00 AM",
    amount: "$10,528",
    status: "Completed",
  },
  {
    key: "5",
    id: "#PA-5769",
    payment: "PlayPalooza Part",
    service: "Tour",
    paymentType: "Stripe",
    date: "18 Jun 2025, 10:00 AM",
    amount: "$12,297",
    status: "Completed",
  },
  {
    key: "6",
    id: "#PA-4742",
    payment: "The Urban Retreat",
    service: "Hotel",
    paymentType: "Card",
    date: "22 Jun 2025, 10:00 AM",
    amount: "$18,349",
    status: "Completed",
  },
  {
    key: "7",
    id: "#PA-9364",
    payment: "Foodie Fiesta",
    service: "Tour",
    paymentType: "Stripe",
    date: "16 Jul 2025, 10:00 AM",
    amount: "$17,875",
    status: "Completed",
  },
  {
    key: "8",
    id: "#PA-6184",
    payment: "Nimbus 345",
    service: "Flight",
    paymentType: "Paypal",
    date: "25 Jul 2025, 10:00 AM",
    amount: "$15,175",
    status: "Completed",
  },
  {
    key: "9",
    id: "#PA-8207",
    payment: "The Grand Horizon",
    service: "Hotel",
    paymentType: "Card",
    date: "14 Jul 2025, 10:00 AM",
    amount: "$12,766",
    status: "Cancelled",
  },
  {
    key: "10",
    id: "#PA-3854",
    payment: " Mercedes-benz ",
    service: "Car",
    paymentType: "Paypal",
    date: "28 Aug 2025, 10:00 AM",
    amount: "$13,496",
    status: "Completed",
  },


];
